import memberDetailsSlice from "./memberDetails";
import priceSummarySlice from "./priceSummary";

export const reducers = {
  member: memberDetailsSlice,
  priceSummary: priceSummarySlice,
};
